import CustomPopover from "@com/components/custom-popover/index.vue";
import { computed, defineComponent } from "vue";
import { filterSchemaConfig } from "@pt/views/pt-entry/components/filter-bar/filter-model";
import i18n from "@/lang";
export default defineComponent({
    components: {
        CustomPopover: CustomPopover
    },
    props: {
        model: Object
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var label = i18n.t("resourceManager.filter.codeRate");
        var popoverSchema = [
            [
                filterSchemaConfig.bitrate_min,
                {
                    label: "-"
                },
                filterSchemaConfig.bitrate_max,
                {
                    label: "Kbps"
                }, 
            ], 
        ];
        var durationPopoverConfig = {
            width: 254
        };
        var durationSelectedValue = computed(function() {
            var min = props.model.bitrate_min;
            var max = props.model.bitrate_max;
            var value = "";
            if (min || max) {
                if (min) {
                    value = "".concat(min, "Kbps\u2264") + value;
                }
                value += i18n.t("resourceManager.filter.codeRate");
                if (max) {
                    value = value + "\u2264".concat(max, "Kbps ");
                }
                return [
                    {
                        label: value,
                        value: "bitrate"
                    }, 
                ];
            }
            return [];
        });
        var handleChange = function(value) {
            emit("change", value);
        };
        var clearValue = [
            {
                prop: "bitrate_min",
                value: 0
            },
            {
                prop: "bitrate_max",
                value: 0
            }, 
        ];
        var deleteTag = function(tag) {
            emit("change", clearValue);
        };
        var handleClearClick = function(event) {
            emit("change", clearValue);
        };
        return {
            label: label,
            durationPopoverConfig: durationPopoverConfig,
            popoverSchema: popoverSchema,
            durationSelectedValue: durationSelectedValue,
            handleChange: handleChange,
            deleteTag: deleteTag,
            handleClearClick: handleClearClick
        };
    }
});
